import useSWR, { useSWRConfig } from "swr";
import { signIn } from "../../../utils/auth/signIn.js";
import { getToken, decodeToken, isTokenExpired } from "../../../utils/auth/wcsToken/index.js";
import { useCallback } from "react";
const SwrOptions = {
  revalidateOnFocus: false,
  revalidateOnReconnect: false
};
const useWcsToken = () => {
  const { mutate } = useSWRConfig();
  const { data, isLoading } = useSWR(
    "getWcsToken",
    getToken,
    SwrOptions
  );
  const getTokenValue = useCallback(
    async (skipSignIn = false) => {
      let { token } = data || {};
      if (token) {
        try {
          const decodedToken = decodeToken(token);
          if (isTokenExpired(decodedToken)) {
            try {
              const updatedData = await mutate(
                "getWcsToken"
              );
              token = updatedData == null ? void 0 : updatedData.token;
            } catch {
              console.error("Refetch SWR token failed");
            }
          }
        } catch {
          console.error("Token decode failed");
        }
      }
      if (!token && !skipSignIn) {
        signIn();
      }
      return token;
    },
    [data, mutate]
  );
  return {
    getTokenValue,
    isLoading
  };
};
export {
  useWcsToken
};
